import { useHistory, useLocation } from 'react-router'

export const useQueryParams = () => {
  const query = new URLSearchParams(useLocation().search)
  const getParam = (name: string) => query.get(name) || ''

  return getParam
}

export const getQueryParamNative = (name: string): string | null => {
  const query = new URLSearchParams(window.location.search)
  return query.get(name)
}

export const useQueryParams2 = () => {
  const location = useLocation()
  const history = useHistory()
  const query = new URLSearchParams(location.search)

  const getParam = (name: string) => query.get(name)

  const setParams = (params: Record<string, string>) => {
    const query = new URLSearchParams(location.search)

    Object.entries(params).forEach(([key, value]) => {
      query.set(key, value)
    })

    history.push({ search: query.toString() })
  }

  const setParamsMerged = (
    params: Record<string, string | null | undefined>
  ) => {
    const query = new URLSearchParams(location.search)
    Object.entries(params).forEach(([key, value]) => {
      if (value === null || value === undefined || value === '') {
        query.delete(key)
      } else {
        query.set(key, value)
      }
    })
    const newSearch = query.toString()
    const currentSearch = location.search.startsWith('?')
      ? location.search.slice(1)
      : location.search
    if (newSearch === currentSearch) return
    history.push({ search: newSearch })
  }

  const setParam = (name: string, value: string) => {
    const query = new URLSearchParams(location.search)
    query.set(name, value)
    history.push({ search: query.toString() })
  }

  const removeParamsWithHash = (paramNames: string[], hash: string) => {
    const query = new URLSearchParams(location.search)
    paramNames.forEach(name => query.delete(name))
    history.push({ search: query.toString(), hash })
  }

  const setParamsWithHash = (params: Record<string, string>, hash: string) => {
    const query = new URLSearchParams(location.search)

    Object.entries(params).forEach(([key, value]) => {
      query.set(key, value)
    })

    history.push({ search: query.toString(), hash })
  }

  const deleteParam = (name: string) => {
    const query = new URLSearchParams(location.search)
    query.delete(name)
    history.push({ search: query.toString() })
  }

  return {
    getParam,
    setParam,
    setParams,
    setParamsMerged,
    setParamsWithHash,
    removeParamsWithHash,
    deleteParam,
  }
}
